
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSoundMuted as ObiSoundMutedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-sound-muted.js';
 
 
 

 
 export const ObiSoundMuted = createComponent({
   react: React,
   tagName: 'obi-sound-muted',
   elementClass: ObiSoundMutedElement,
   events: {
     
   }
  });
 
 